import React from "react";

import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";

import RbGrid from "../RbGrid";

const useStyles = makeStyles(({ palette: { grey } }) => ({
  label: {
    display: "block",
    color: grey[500],
    fontSize: "0.78rem",
  },
}));

const RbLabeledGrid = React.forwardRef(function RbLabeledGrid(props, ref) {
  const { children, label, ...other } = props;

  const classes = useStyles(props);

  return (
    <RbGrid {...other} ref={ref}>
      {label && <span className={classes.label}>{label}</span>}
      {children}
    </RbGrid>
  );
});

RbLabeledGrid.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
};

RbLabeledGrid.defaultProps = {
  children: null,
  label: null,
};

export default RbLabeledGrid;
